/**
 * Build the plain-text (.txt) export payload for a sermon and trigger
 * a browser download. Kept as a free-standing helper so the main
 * component stays render-focused.
 */
export function exportSermonAsTxt({ topic, notes, outline, research }, language = 'en') {
  let text = `SERMON PREPARATION: ${topic}\n${'='.repeat(50)}\n\n`;

  if (notes) text += `NOTES:\n${notes}\n\n`;

  text += `OUTLINE:\n${'-'.repeat(50)}\n`;
  outline.forEach((point, idx) => {
    text += `\n${idx + 1}. ${point.title}\n`;
    if (point.content) text += `   ${point.content}\n`;
  });

  if (research) {
    text += `\n\n${'='.repeat(50)}\nBIBLICAL RESEARCH\n${'='.repeat(50)}\n\n`;

    if (research.key_verses?.length > 0) {
      text += `KEY VERSES:\n${'-'.repeat(50)}\n`;
      research.key_verses.forEach((v) => {
        text += `\n${v.reference} (${v.translation})\n"${v.text}"\n`;
        if (v.relevance) text += `Relevance: ${v.relevance}\n`;
      });
      text += `\n`;
    }

    if (research.concordance?.word_occurrences?.length > 0) {
      text += `\nCONCORDANCE:\n${'-'.repeat(50)}\n`;
      research.concordance.word_occurrences.forEach((w) => {
        text += `\n${w.word.toUpperCase()}`;
        if (w.hebrew_greek) text += ` (${w.hebrew_greek})`;
        text += `\nDefinition: ${w.definition}\n`;
        if (w.key_references) text += `Key References: ${w.key_references.join(', ')}\n`;
      });
      text += `\n`;
    }

    if (research.biblical_dictionary?.length > 0) {
      text += `\nBIBLICAL DICTIONARY:\n${'-'.repeat(50)}\n`;
      research.biblical_dictionary.forEach((e) => {
        text += `\n${e.term.toUpperCase()}\n${e.definition}\n\n`;
        if (e.old_testament_usage) text += `Old Testament: ${e.old_testament_usage}\n`;
        if (e.new_testament_usage) text += `New Testament: ${e.new_testament_usage}\n`;
        if (e.theological_significance) text += `Theological Significance: ${e.theological_significance}\n`;
        text += `\n`;
      });
    }

    if (research.themes?.length > 0) {
      text += `\nTHEOLOGICAL THEMES:\n${'-'.repeat(50)}\n`;
      research.themes.forEach((t, idx) => {
        const theme = t.theme || t;
        text += `\n${idx + 1}. ${theme}\n`;
        if (t.explanation) text += `   ${t.explanation}\n`;
        if (t.supporting_verses) text += `   Supporting Verses: ${t.supporting_verses.join(', ')}\n`;
      });
      text += `\n`;
    }

    if (research.application?.length > 0) {
      text += `\nAPPLICATION POINTS:\n${'-'.repeat(50)}\n`;
      research.application.forEach((p, idx) => { text += `${idx + 1}. ${p}\n`; });
      text += `\n`;
    }

    if (research.cross_references?.length > 0) {
      text += `\nCROSS REFERENCES:\n${'-'.repeat(50)}\n`;
      research.cross_references.forEach((ref) => {
        const reference = ref.reference || ref;
        text += `• ${reference}`;
        if (ref.connection) text += ` - ${ref.connection}`;
        text += `\n`;
      });
    }
  }

  const blob = new Blob([text], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `sermon_${(topic || 'untitled').replace(/\s+/g, '_')}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
